import { render, staticRenderFns } from "./AddressTable.vue?vue&type=template&id=d834658a&"
import script from "./AddressTable.vue?vue&type=script&lang=js&"
export * from "./AddressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports